<div id="headerWrapper"
    class="finder-syndicated-header-wrapper"
    [@headerState]="stateName"
    (@headerState.done)="headerStateDone($event)">
    <finder-script-loader [src]="syndicatedHeaderUrl"></finder-script-loader>
</div>
